'use client';

import { useEffect, useRef, useState } from 'react';

import { Badge } from '@mantine/core';

import { useSnapshot } from 'hooks/use-safe-snapshot';
import { ImpersonationService } from 'services/ImpersonationService';

import cx from './ImpersonationBadge.module.scss';

const ImpersonationBadge = () => {
    const { impersonating } = useSnapshot(ImpersonationService.state);

    return impersonating ? (
        <Badge className={cx.badge} size="lg" radius="sm" color="red" variant="filled">
            Impersonating
        </Badge>
    ) : null;
};

export { ImpersonationBadge };
